import { MAIN_CATEGORY_ENVELOPE, MAIN_CATEGORY_OTHERS } from '../api/legacy/utils';
import { ShipmentType, Item, Parcel } from '../types/common';

export const shipmentMap = {
  [ShipmentType.DOCUMENT]: 'envelope',
  [ShipmentType.PARCEL]: 'package',
};

export const getDimenstions = ({ length, width, height }: Parcel): string => {
  const descendingDimenstions = [length, width, height].sort((a, b) => b - a);
  return descendingDimenstions.join('-');
};

export const getWeightCategory = (weight: number): string => {
  switch (true) {
    case weight < 2:
      return '0-1 kg';
    case weight < 5:
      return '2-4 kg';
    case weight < 10:
      return '5-9 kg';
    case weight < 21:
      return '10-20 kg';
    case weight <= 45:
      return '21-44 kg';
    case weight < 71:
      return '45-70 kg';
    case weight < 100:
      return '71-99 kg';
    case weight < 300:
      return '100-299 kg';
    case weight < 500:
      return '300-499 kg';
    default:
      return '500-999 kg';
  }
};

export const convertItems = (
  type: ShipmentType,
  items: Item[],
): Record<'category' | 'description', string>[] =>
  items.map(({ description }) => {
    return {
      category: type === ShipmentType.DOCUMENT ? MAIN_CATEGORY_ENVELOPE : MAIN_CATEGORY_OTHERS,
      description,
    };
  });
